import { render, staticRenderFns } from "./edit-tatics.vue?vue&type=template&id=3df7ac8c&scoped=true"
import script from "./edit-tatics.vue?vue&type=script&lang=ts"
export * from "./edit-tatics.vue?vue&type=script&lang=ts"
import style0 from "./edit-tatics.vue?vue&type=style&index=0&id=3df7ac8c&prod&lang=less&scoped=true"
import style1 from "./edit-tatics.vue?vue&type=style&index=1&id=3df7ac8c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df7ac8c",
  null
  
)

export default component.exports